import { authRoles } from 'app/auth';
import TobbszorosKerdesTable from 'app/admin/tobbszoroskerdes/table/TobbszorosKerdesTable';
import TobbszorosKerdesEditForm from 'app/admin/tobbszoroskerdes/editform/TobbszorosKerdesEditForm';

export default [
	{
		path: '/tobbszoroskerdes/edit/:id',
		component: TobbszorosKerdesEditForm,
		auth: authRoles.admin
	},
	{
		path: '/tobbszoroskerdes/:sessionNameParam?',
		component: TobbszorosKerdesTable,
		auth: authRoles.admin
	}
];
